import React from "react";
import ReadSciencesCom from "../components/recommendations/ReadSciences";

export default function RecommendationsPage() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold col-span-12">Tavsiya</h1>
      <ReadSciencesCom />
    </div>
  );
}
